module.exports = __webpack_public_path__ + "static/ConsumerSignUp1-6603f6f967be6a0e234ce67906f5d30c.png";